import React from "react"
import Modal from "react-modal"
import Button from "@components/Button/Button"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
}

Modal.setAppElement(`#___gatsby`)

function Popup(props) {
  return (
    <Modal
      isOpen={props.show}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="space-y-3 text-center">
        <h2>{props.title}</h2>
        <p>{props.body}</p>
        <button
          onClick={props.onClose}
          className="font-family[inherit] my-1 inline-block cursor-pointer rounded-sm border-0 bg-fehr-500 px-5 py-2.5 text-center font-medium text-white hover:bg-white hover:text-fehr-600 hover:outline hover:outline-1 hover:outline-offset-1 hover:outline-fehr-600"
        >
          {props.close_button}
        </button>
      </div>
    </Modal>
  )
}

export default Popup
